import React from 'react';
import { motion } from 'framer-motion';
import { 
  UsersIcon,
  ChartBarIcon,
  EyeIcon,
  HeartIcon,
  ClockIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';

const AudienceAnalysisPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center mb-4">
              <UsersIcon className="h-8 w-8 text-purple-600 mr-3" />
              <h1 className="text-3xl font-bold text-gray-900">Audience Analysis</h1>
            </div>
            <p className="text-lg text-gray-600">
              Deep insights into your audience demographics, interests, and behavior patterns.
            </p>
          </motion.div>
        </div>

        {/* Coming Soon Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center"
        >
          <div className="max-w-md mx-auto">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <UsersIcon className="h-8 w-8 text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon</h2>
            <p className="text-gray-600 mb-6">
              We're working on advanced audience analysis features that will help you understand your target market better.
            </p>
            <div className="space-y-4 text-left">
              <div className="flex items-center text-gray-700">
                <ChartBarIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Demographic breakdowns</span>
              </div>
              <div className="flex items-center text-gray-700">
                <EyeIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Interest mapping</span>
              </div>
              <div className="flex items-center text-gray-700">
                <HeartIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Engagement patterns</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ClockIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Behavioral timing</span>
              </div>
              <div className="flex items-center text-gray-700">
                <MapPinIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Geographic insights</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AudienceAnalysisPage;
